export default {
	Monthly: "Monthly",
	Annual: "Annual"
}